import React, { useState, useEffect, useRef } from 'react';
import { menuConfig } from '../config/menuConfig';

const TopBar = ({
    notifCount, setNotifCount,
    user, isUserDropdownOpen, setIsUserDropdownOpen,
    userMenuRef, navigate, handleLogout, setIsPassModalOpen
}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const searchRef = useRef(null);

    const userRoleName = (user?.RoleName || '').toLowerCase();
    const isManager = user?.RoleId === 1 || user?.RoleId === 11 || userRoleName === 'quản trị viên' || userRoleName.includes('quản lý khoa');

    const handleSearchChange = (e) => {
        const val = e.target.value;
        setSearchTerm(val);

        if (!val.trim()) {
            setSearchResults([]);
            setIsSearchOpen(false);
            return;
        }

        const lowerVal = val.toLowerCase();
        const results = [];

        Object.values(menuConfig).forEach(section => {
            if (section.isAdminMenu && !isManager) return;

            section.items.forEach(item => {
                if (item.name.toLowerCase().includes(lowerVal)) {
                    results.push({
                        ...item,
                        sectionLabel: section.label
                    });
                }
            });
        });

        setSearchResults(results);
        setIsSearchOpen(true);
    };

    const handleResultClick = (path) => {
        navigate(path);
        setSearchTerm('');
        setIsSearchOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setIsSearchOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <header className="top-header" style={{
            backgroundColor: '#003399', height: '60px', display: 'flex',
            alignItems: 'center', padding: '0 25px', justifyContent: 'space-between',
            color: '#fff', boxShadow: '0 2px 5px rgba(0,0,0,0.1)', position: 'relative',
            zIndex: 100
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>

                <div className="search-wrapper" style={{ position: 'relative' }} ref={searchRef}>
                    <i className="fa-solid fa-magnifying-glass search-icon-white"></i>
                    <input
                        type="text"
                        placeholder="Tìm kiếm"
                        className="topbar-search-input"
                        value={searchTerm}
                        onChange={handleSearchChange}
                        onFocus={() => {
                            if (searchTerm.trim()) setIsSearchOpen(true);
                        }}
                    />

                    {isSearchOpen && (
                        <div className="search-results-dropdown" style={{
                            position: 'absolute',
                            top: '45px',
                            left: '0',
                            backgroundColor: '#fff',
                            color: '#333',
                            width: '320px',
                            maxHeight: '400px',
                            overflowY: 'auto',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                            borderRadius: '8px',
                            padding: '8px 0',
                            zIndex: 1000
                        }}>
                            {searchResults.length > 0 ? (
                                searchResults.map((result, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            padding: '10px 16px',
                                            cursor: 'pointer',
                                            borderBottom: index !== searchResults.length - 1 ? '1px solid #eee' : 'none',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '12px'
                                        }}
                                        onClick={() => handleResultClick(result.path)}
                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4f8'}
                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                                    >
                                        <i className={`${result.icon}`} style={{ color: '#003399', width: '20px', textAlign: 'center' }}></i>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <span style={{ fontWeight: '500', fontSize: '14px', color: '#333' }}>{result.name}</span>
                                            <span style={{ fontSize: '12px', color: '#888' }}>{result.sectionLabel}</span>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div style={{ padding: '16px', textAlign: 'center', color: '#888', fontSize: '14px' }}>
                                    Không tìm thấy chức năng phù hợp.
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '25px' }}>
                <div style={{ position: 'relative', cursor: 'pointer' }} onClick={() => setNotifCount(0)}>
                    <i className="fa-regular fa-bell" style={{ fontSize: '20px', color: '#fff' }}></i>
                    {notifCount > 0 && (
                        <span className="notif-badge">{notifCount}</span>
                    )}
                </div>

                <div style={{ position: 'relative' }} ref={userMenuRef}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }}
                        onClick={() => setIsUserDropdownOpen(!isUserDropdownOpen)}>
                        <div style={{ textAlign: 'right' }}>
                            <div style={{ fontSize: '14px', fontWeight: '600', color: '#fff' }}>
                                {user?.FullName || user?.Username || "Người dùng"}
                            </div>
                        </div>
                        <div className="user-avatar-circle">
                            {user?.AvatarUrl ? (
                                <img src={user.AvatarUrl} alt="Avatar" />
                            ) : (user?.FirstName?.charAt(0) || 'U')}
                        </div>
                    </div>

                    {isUserDropdownOpen && (
                        <div className="user-menu-dropdown">
                            <div className="dropdown-header">
                                <div className="avatar-large">
                                    {user?.AvatarUrl ? (
                                        <img src={user.AvatarUrl} alt="Avatar" />
                                    ) : (user?.FirstName?.charAt(0) || 'U')}
                                </div>
                                <div style={{ overflow: 'hidden' }}>
                                    <strong style={{ display: 'block', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                        {user?.LastName} {user?.FirstName}
                                    </strong>
                                    <p style={{ margin: 0, fontSize: '12px', color: '#888', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                        {user?.Email}
                                    </p>
                                </div>
                            </div>
                            <div className="dropdown-divider"></div>
                            <div className="dropdown-item" onClick={() => { navigate('/thong-tin-lien-he'); setIsUserDropdownOpen(false); }}>
                                <i className="fa-regular fa-user"></i> Hồ sơ của tôi
                            </div>
                            <div className="dropdown-item" onClick={() => { setIsPassModalOpen(true); setIsUserDropdownOpen(false); }}>
                                <i className="fa-solid fa-key"></i> Đổi mật khẩu
                            </div>
                            <div className="dropdown-divider"></div>
                            <div className="dropdown-item logout" onClick={handleLogout}>
                                <i className="fa-solid fa-arrow-right-from-bracket"></i> Đăng xuất
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

export default TopBar;